import React from 'react';

// Components
import ManagedPhotoDeleter from './ManagedPhotoDeleter';

const ManagedPhoto = ({ id, url, updateParticipation }) => (
  <div className="managed-photo content" style={{backgroundImage: `url(${url})`}}>
    <ManagedPhotoDeleter photoID={id} updateParticipation={updateParticipation} />
  </div>
)

export default ManagedPhoto



// WEBPACK FOOTER //
// ./src/components/UserPortal/Locker/PhotoVideo/ManagedPhoto.js